export default {
    computed: {
        isParcVersion() {
            return process.env.VUE_APP_STATIONS_VERSION === 'parc';
        },
    },
};
